import { useEffect, useRef, useState } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";

import { DeleteOutline, FolderOpenOutlined } from "@mui/icons-material";
import { IconButton, ListItem, ListItemIcon, ListItemText } from "@mui/material";

import { nmckActions } from "slices/nmck/nmckSlice";
import { createNmckGroup } from "slices/nmck/services/createNmckGroup";
import { editNmckGroup } from "slices/nmck/services/editNmckGroup";

import { NmckTextField } from "../NmckTextField/NmckTextField";
import styles from "./NmckList.module.css";
import { NmckListItem } from "./NmckListItem";

export const NmckGroupItem = ({ id, name, index, setDeleteDialogData, children }) => {
	const dispatch = useDispatch();
	const setFetchStatus = (newValue) => dispatch(nmckActions.setFetchStatus(newValue));
	const setFetchStatusText = (newValue) => dispatch(nmckActions.setFetchStatusText(newValue));

	const inputRef = useRef(null);

	const [value, setValue] = useState(name);
	const [focused, setFocused] = useState(id === 0 ? true : false);

	const saveName = () => {
		if (value === name) {
			setFocused(false);
			return;
		}
		if (!value) {
			setFetchStatus("failed");
			setFetchStatusText("Значение не должно быть пустым");
			setFocused(false);
			return;
		}
		if (id === 0) {
			dispatch(createNmckGroup({ name: value }));
		} else {
			dispatch(
				editNmckGroup({
					id,
					name: value,
				})
			);
		}
		setFocused(false);
	};

	useEffect(() => {
		if (focused) {
			inputRef.current.focus();
		}
	}, [focused]);

	return (
		<>
			<Draggable isDragDisabled draggableId={`draggable-group-${id}`} index={index}>
				{(provided) => (
					<ListItem
						disablePadding
						ref={provided.innerRef}
						title={name}
						className={styles.itemContainer}
						onClick={() => setFocused(true)}
						sx={({ palette }) => ({
							position: "relative",
							height: "26px",
							color: palette.text.primary,
							cursor: "pointer",
							transform: "none!important",
						})}
						{...provided.draggableProps}
					>
						<ListItemIcon sx={{ minWidth: "22px" }} {...provided.dragHandleProps}>
							<FolderOpenOutlined color="disabled" sx={{ fontSize: "16px" }} />
						</ListItemIcon>
						{focused ? (
							<NmckTextField
								disableBorder
								inputRef={inputRef}
								value={value}
								setValue={setValue}
								onBlurCallback={saveName}
								onKeyDownCallback={saveName}
								sx={{
									"& .MuiOutlinedInput-input": {
										padding: "0px",
										fontSize: "14px",
									},
								}}
							/>
						) : (
							<>
								<ListItemText
									primary={value}
									primaryTypographyProps={{
										noWrap: true,
										sx: { fontSize: "14px" },
									}}
									sx={{ margin: "0px 16px 0px 0px" }}
								/>
								<IconButton
									size="small"
									className={styles.deleteButton}
									onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
										setDeleteDialogData({
											id,
											name,
											type: "Group",
										});
									}}
								>
									<DeleteOutline sx={{ fontSize: "16px" }} />
								</IconButton>
							</>
						)}
					</ListItem>
				)}
			</Draggable>
			<Droppable droppableId={`${index}-droppable-group-${id}`}>
				{(provided) => (
					<div ref={provided.innerRef} {...provided.droppableProps}>
						{children.map(({ key, id, name }, index) => (
							<NmckListItem grouped key={key} id={id} index={index} name={name} setDeleteDialogData={setDeleteDialogData} />
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</>
	);
};
